import { useContractElements } from './hooks'
import { ElementCard } from './components/ElementCard'

export function ElementsTab({ contractId }: { contractId: number }) {
  const elementsQ = useContractElements(contractId)

  if (elementsQ.isLoading) return <div className="p-6 text-sm text-slate-500">Ładowanie elementów...</div>
  if (elementsQ.isError) return <div className="p-6 text-sm text-red-600">Błąd ładowania elementów.</div>

  const elements = elementsQ.data ?? []

  if (elements.length === 0) {
    return (
      <div className="p-6 text-sm text-slate-400 italic">
        Ta umowa nie ma elementów (konfiguracja bez kompozycji produktów).
      </div>
    )
  }

  return (
    <div className="p-6 flex flex-col gap-2 max-w-2xl">
      <p className="text-xs text-slate-500">
        Elementy umowy wynikają z kompozycji konfiguracji. Każdy ma własny etap realizacji.
      </p>
      {elements.map(e => (
        <ElementCard key={e.id} contractId={contractId} element={e} />
      ))}
    </div>
  )
}
